var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicture4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-505 -199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515 205.5 512 205.5 512 240.5 546.5 240.5 546.5 237.5 515 237.5 515 205.5Z",
    fill: "#D3BA68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.5 234.5 539 234.5 539 205.5 546.5 205.5Z",
    fill: "#D3BA68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536 234.5 528.5 234.5 528.5 215.5 536 215.5Z",
    fill: "#D3BA68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.5 234.5 518 234.5 518 224.5 525.5 224.5Z",
    fill: "#D3BA68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 212.37 534 205.5 527.13 205.5 529.86 208.23 517.795 220.295 519.205 221.705 531.27 209.645 534 212.37Z",
    fill: "#D3BA68"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture4);
export default __webpack_public_path__ + "static/media/Picture4.5d3781853f6aa6a3f2cdaeff3c2b48e3.svg";
export { ForwardRef as ReactComponent };